module.exports = __webpack_public_path__ + "img/fk.6ef4f02a.svg";